import { z } from 'zod';
// ── crearListaFestivosSchema — POST /dias-festivos-listas (Prompt AC) ────────
export const crearListaFestivosSchema = z
    .object({
    nombre: z.string().min(1).max(100),
    anio: z.coerce.number().int(),
    fecha_inicio: z.string().date(),
    fecha_fin: z.string().date(),
})
    .refine(d => d.fecha_inicio < d.fecha_fin, {
    message: 'fecha_inicio debe ser anterior a fecha_fin',
    path: ['fecha_fin'],
});
// ── agregarFechaSchema — POST /dias-festivos-listas/:id/fechas ───────────────
// Sirve tanto para un festivo oficial puntual como para reactivar/agregar un
// fin de semana específico (caso: se había quitado por excepción).
export const agregarFechaSchema = z.object({
    fecha: z.string().date(),
    descripcion: z.string().min(1).max(150),
    tipo: z.enum(['fin_de_semana', 'festivo_oficial']),
});
// ── eliminarFechasLoteSchema — DELETE /dias-festivos-listas/:id/fechas ───────
// Borrado en lote (Prompt AC-3) — una sola operación en vez de N DELETEs
// individuales concurrentes (causa real del "error de servidor" reportado).
export const eliminarFechasLoteSchema = z.object({
    fechaIds: z.array(z.string().uuid()).min(1),
});
// ── toggleActivaListaSchema — PATCH /dias-festivos-listas/:id/activa (Prompt BB-1) ──
export const toggleActivaListaSchema = z.object({
    activa: z.boolean(),
});
//# sourceMappingURL=dias-festivos.js.map